import { Injectable, inject } from "@angular/core";
import { Params, Router } from "@angular/router";
import { MibpLogFilterItem, MibpLogSearchRequest } from "./operations.types";
import { BroadcastService, PermissionService } from 'root/services';
import { UrlHelperService } from './../url-helper/url-helper.service';
import { QueryCountResult } from "../mibp-http-api/operations-http-service.class";
import { BehaviorSubject } from "rxjs";

import { format, startOfDay } from "date-fns";
import { IntegrationMessageTypeVm, resubmittableIntegrationMessageTypes } from "root/modules/operations/pages/post-integration-messages/post-integration-message.types";
export interface QueueCountEvent {
  result: QueryCountResult;
  nextUpdate: Date;
}

@Injectable({
  providedIn: 'root'
})
export class MibpOperationsService {
  private router = inject(Router);
  private broadcast = inject(BroadcastService);
  private urlHelper = inject(UrlHelperService);
  private permissionService = inject(PermissionService);


  queueCountSubject = new BehaviorSubject<QueueCountEvent>(null);
  queueFetchTime?: Date;
  queueRefreshTimeMs = 60000;

  constructor() {
  }

  public getResubmittableIntegrationMessageTypes(): IntegrationMessageTypeVm[]{
    return resubmittableIntegrationMessageTypes;
  }

  abbreviateNumber(value: number): string {
    let newValue = value.toString();
    if (value >= 1000) {
      const suffixes = ["", "k", "m", "b","t"];
      const suffixNum = Math.floor( (""+value).length/3 );
      let shortValue: number | string = 0;
      for (let precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
        const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
        if (dotLessShortValue.length <= 2) { break; }
      }
      if (shortValue % 1 != 0) {
        shortValue = shortValue.toFixed(1);
      }
      newValue = shortValue+suffixes[suffixNum];
    }
    return newValue;
  }


  navigateToLogSearch(type: 'userevents' | 'logrows' | 'integration', request?: MibpLogSearchRequest, navigateUsingBrowser = false): void {

    const nav = this.getLogSearchRoute(type, request);

    if (navigateUsingBrowser) {
      window.location.href = this.urlHelper.create(nav.route[0], nav.queryParams).toString();

    } else {
      this.router.navigate(nav.route, {queryParams: nav.queryParams});
    }

  }

  public getLogSearchRoute(type: 'userevents' | 'logrows' | 'integration', request?: MibpLogSearchRequest): { route: string[], queryParams: Params } {

    let url = `/${this.broadcast.snapshot.language}/operations/logs/${type}`;
    const param: Params = {
      q: JSON.stringify(request)
    };

    if (type === 'integration' || type === 'userevents') {
      url = `/${this.broadcast.snapshot.language}/operations/logs/${type}/search`;
    }

    return {
      route: [url],
      queryParams: param
    };

  }

  public createStartOfDayFilter(): MibpLogFilterItem {
    const date = format(startOfDay(new Date()), `yyyy-MM-dd`);
    const dateString = `${date}T00:00:00Z`;

    return {
      field: 'LogDate',
      operator: '>=',
      value: dateString,
      dateTz: 'utc',
      type: 'condition'
    };
  }

  // SAve this a bit in case we need to use zipped filters in url

  // import { compress, decompress } from "lzutf8";
  // import { MibpLogSearchRequest } from "../../modules/operations/components/mibplog-filter-editor/mibplog-filter-editor.types";
  // import { Router } from '@angular/router';
  // import { BroadcastService } from 'root/services';
  // import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

  // @Injectable({
  //   providedIn: 'root'
  // })
  // export class MibpLogFilterService {


  //   public constructor(private router: Router,
  //                     private broadcast: BroadcastService,
  //                     private sanitizer: DomSanitizer) {}

  //   public toQuerystringValue(request: MibpLogSearchRequest): string {

  //     const compressedFilter = compress(JSON.stringify(request), {
  //       outputEncoding: 'BinaryString'
  //     });

  //     return `bstr${compressedFilter}`;
  //   }


}
